import { createFileRoute } from '@tanstack/react-router';
import CollateralClauseEdit from '../../../features/baseData/collateralClauses/collateralClause/edit';
import {
  COLLATERAL_CLAUSES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten',
)({
  component: CollateralClauseEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COLLATERAL_CLAUSES_PERMISSIONS, 'EDIT'),
  ),
});

export const EditCollateralClauseRoute = Route;
